import React from "react";
import "./blog.css";

function Blog() {

    
        return(
            <div className="container">
                <h1 className="text-center blog-heading mb-4">Blogs</h1>
                <p className="blog-para text-center">No posts for now</p>
            </div>
        )
    
};

export default Blog;